/**
 * MeusNegocios — DEPRECATED (v32, 2026-07-16)
 *
 * A partir da v32 (unificação /meu-perfil + /meus-negocios), toda a gestão
 * de negócios do empreendedor vive em `/perfil?tab=negocios`, incluindo:
 *   - Lista de negócios (MyBusinessCard com % de completude)
 *   - Jornada de Evolução, Search Trends, Promoções, Validar Cupom
 *   - "Cadastros incompletos" (drafts) — antes exclusivo desta página
 *   - Campanhas do município
 *
 * Este arquivo permanece apenas para manter links antigos (bookmarks,
 * atalhos internos, redirects após POST /businesses etc.) funcionando —
 * ele apenas redireciona para o hub unificado, preservando a query string
 * `?continue=<draft-id>` caso alguém abra `/meus-negocios?continue=...`.
 */
import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';

export default function MeusNegocios() {
  const location = useLocation();

  // Preservar querystring quando existir; anexar `tab=negocios` no fim.
  const params = new URLSearchParams(location.search);
  params.set('tab', 'negocios');

  useEffect(() => {
    // Log leve para audit — ajuda a saber quando podemos remover o arquivo.
    if (typeof window !== 'undefined' && window.console) {
      console.info('[/meus-negocios] rota descontinuada — redirecionando para /perfil?tab=negocios');
    }
  }, []);

  return <Navigate to={`/perfil?${params.toString()}`} replace />;
}
